import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Modal, Typography } from '@mui/material'

import { OrderListItems } from './InvoiceList'
import OrderItemList from './OrderItemList'

export default function OrderItemModal({
  orderItems,
  setShowOrderModal
}: {
  orderItems: OrderListItems[]
  setShowOrderModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <Modal open={true}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95vw', sm: '90vw', md: '85vw', lg: '80vw' },
          maxWidth: '1400px',
          height: { xs: '90vh', sm: '85vh', md: '80vh' },
          maxHeight: '900px',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden' 
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 3,
            py: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'grey.50'
          }}
        >
          <Typography variant='h5' sx={{ fontWeight: 600 }}>
            Order Items List
          </Typography>
          <IconButton
            onClick={() => setShowOrderModal(false)}
            size='small'
            sx={{
              '&:hover': {
                backgroundColor: 'error.light',
                color: 'error.contrastText'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          <OrderItemList data={orderItems} />
        </Box>
      </Box>
    </Modal>
  )
}
